import React from "react";
import { Link } from "react-router-dom";
import { SECTION_LINKS, STORE_LINKS } from "./siteLinks";

const linkClass = "text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200";

function FooterLink({ link }) {
  return link.to ? (
    <Link to={link.to} className={linkClass}>
      {link.label}
    </Link>
  ) : (
    <a href={link.href} className={linkClass}>
      {link.label}
    </a>
  );
}

/** Разделы и все магазины в подвале: человеку — быстрый переход, поисковику — ссылки на каждую страницу. */
function SiteFooterLinks() {
  return (
    <nav className="site-footer-links" aria-label="Разделы сайта">
      <div className="site-footer-row">
        {SECTION_LINKS.map((link) => (
          <FooterLink key={link.id} link={link} />
        ))}
      </div>
      <div className="site-footer-row">
        <span className="site-footer-caption">Другие магазины:</span>
        {STORE_LINKS.map((link) => (
          <FooterLink key={link.id} link={link} />
        ))}
      </div>
    </nav>
  );
}

export default SiteFooterLinks;
